import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";

export function createServicesApproachSection(approach) {
  const section = document.createElement("section");
  section.id = "approach";
  section.className = "section services-approach";

  section.innerHTML = `
    <div class="section__inner">
      <header class="section__header reveal">
        ${buildSectionPillRow(approach.badge)}
        <h2>${buildAnimatedHeading(approach.titleSegments)}</h2>
        <p>${approach.subtitle}</p>
      </header>

      <div class="services-approach__rail">
        <div class="services-approach__grid">
          ${approach.steps
            .map(
              (step, i) => `
            <article class="services-approach__card reveal" style="--delay: ${0.1 + i * 0.12}s; --card-i: ${i}">
              <span class="services-approach__index">0${i + 1}</span>
              <h3>${step.title}</h3>
              <p>${step.description}</p>
            </article>
          `
            )
            .join("")}
        </div>
      </div>
    </div>
  `;

  return section;
}
